import firebase from "firebase/app";
import smartquotes from "smartquotes";
import "./firebaseConfig";
import constants from "./constants";
import store from "./store";

import "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";

const dataNames = constants.dataNames;

export const dbFs = firebase.firestore();
export const storage = firebase.storage();
export const db = firebase.database();

const validPlanTypes = [
  dataNames.subscriptions.type.free,
  dataNames.subscriptions.type.paid
];

export const getStripeCustomerId = () => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "getStripeCustomerId" +
              "?token=" +
              encodeURIComponent(idToken)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const getStripeCustomerDetails = () => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "getStripeCustomerDetails" +
              "?token=" +
              encodeURIComponent(idToken)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const updateStripeCustomerDetails = (
  firstName,
  lastName,
  phone,
  company,
  address1,
  address2,
  city,
  state,
  zip,
  auto_collection
) => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "updateStripeCustomerDetails" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&firstName=" +
              encodeURIComponent(firstName) +
              "&lastName=" +
              encodeURIComponent(lastName) +
              "&phone=" +
              encodeURIComponent(phone) +
              "&company=" +
              encodeURIComponent(company) +
              "&address1=" +
              encodeURIComponent(address1) +
              "&address2=" +
              encodeURIComponent(address2) +
              "&city=" +
              encodeURIComponent(city) +
              "&state=" +
              encodeURIComponent(state) +
              "&zip=" +
              encodeURIComponent(zip) +
              "&auto_collection=" +
              encodeURIComponent(auto_collection)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const addCreditCardDetails = stripeToken => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "addCreditCardDetails" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&stripeToken=" +
              encodeURIComponent(stripeToken)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const updateCreditCardDetails = (firstName, lastName) => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "updateCreditCardDetails" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&firstName=" +
              encodeURIComponent(firstName) +
              "&lastName=" +
              encodeURIComponent(lastName)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const getCreditCardDetails = () => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "getCreditCardDetails" +
              "?token=" +
              encodeURIComponent(idToken)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const deleteCreditCard = () => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "deleteCreditCard" +
              "?token=" +
              encodeURIComponent(idToken)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const createNewSubscription = (
  plan_quantity,
  friendly_name,
  plan_type,
  company_name,
  billing_address
) => {
  return new Promise((resolve, reject) => {
    if (!(typeof plan_quantity === "number" && plan_quantity > 0)) {
      reject("Invalid quantity!");
      return;
    } else if (!isNonEmptyString(friendly_name)) {
      reject("Invalid name!");
      return;
    } else if (
      !(isNonEmptyString(plan_type) && validPlanTypes.includes(plan_type))
    ) {
      reject("Invalid type!");
      return;
    } else if (!store.state.user) {
      reject("User not logged in!");
      return;
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          let fetchUrl =
            constants.urls.functionsBase +
            "createNewSubscription" +
            "?token=" +
            encodeURIComponent(idToken) +
            "&plan_quantity=" +
            encodeURIComponent(plan_quantity) +
            "&plan_type=" +
            encodeURIComponent(plan_type) +
            "&friendly_name=" +
            encodeURIComponent(friendly_name) +
            "&company_name=" +
            encodeURIComponent(company_name) +
            "&billing_address=" +
            encodeURIComponent(billing_address);

          fetch(fetchUrl)
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const updateSubscription = (
  id,
  new_users_qty,
  friendly_name,
  company_name,
  billing_address
) => {
  return new Promise((resolve, reject) => {
    const parsedUserQty = parseInt(new_users_qty);

    if (
      (!isNaN(parsedUserQty) && new_users_qty <= 0) || //is number less than or equal to 0
      (new_users_qty && isNaN(parsedUserQty)) //has value that is not a number
    ) {
      reject("Invalid quantity!");
      return;
    }
    if (!isNonEmptyString(friendly_name)) {
      reject("Invalid name!");
      return;
    }
    if (!isNonEmptyString(company_name)) {
      reject("Invalid Company name!");
      return;
    }
    if (!isNonEmptyString(billing_address)) {
      reject("Invalid Billing address !");
      return;
    }
    if (!isNonEmptyString(id)) {
      reject("Invalid subscription id!");
      return;
    }
    if (!store.state.user) {
      reject("User not logged in!");
      return;
    }
    let user = firebase.auth().currentUser;
    if (user) {
      user.getIdToken().then(function(idToken) {
        let fetchUrl =
          constants.urls.functionsBase +
          "updateSubscription" +
          "?token=" +
          encodeURIComponent(idToken) +
          "&id=" +
          encodeURIComponent(id) +
          "&friendly_name=" +
          encodeURIComponent(friendly_name) +
          "&company_name=" +
          encodeURIComponent(company_name) +
          "&billing_address=" +
          encodeURIComponent(billing_address);
        if (new_users_qty > 0) {
          fetchUrl += "&new_users_qty=" + encodeURIComponent(new_users_qty);
        }

        fetch(fetchUrl)
          .then(response => response.json())
          .then(json => {
            if (json.error) {
              reject(json.error);
            } else {
              resolve(json);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  });
};

export const getUserSubscriptions = () => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "getUserSubscriptions" +
              "?token=" +
              encodeURIComponent(idToken)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const getUserInvoices = () => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "getUserInvoices" +
              "?token=" +
              encodeURIComponent(idToken)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const downloadInvoiceAsPdf = id => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "downloadInvoiceAsPdf" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&id=" +
              encodeURIComponent(id)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const cancelSubscription = id => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "cancelSubscription" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&id=" +
              encodeURIComponent(id)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const reactivateSubscription = id => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "reactivateSubscription" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&id=" +
              encodeURIComponent(id)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const getSubscriptionDetails = id => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "getSubscriptionDetails" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&id=" +
              encodeURIComponent(id)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

// export const listChargebeePlans = () => {
// 	return new Promise((resolve, reject) => {
// 		fetch(constants.urls.functionsBase + "listChargebeePlans")
// 			.then(response => response.json())
// 			.then(json => {
// 				if (json.error) {
// 					reject(json.error);
// 				} else {
// 					resolve(json);
// 				}
// 			})
// 			.catch(error => {
// 				reject(error);
// 			});
// 	});
// };
export const getUserByOnlyEmail = email => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject("No User logged in!");
      return;
    }
    if (!email || typeof email !== "string") {
      reject("Invalid email!");
      return;
    }
    // if (!subscriptionId || typeof subscriptionId !== "string") {
    //   reject("Invalid subscription id!");
    //   return;
    // }

    let user = firebase.auth().currentUser;
    if (user) {
      user.getIdToken().then(function(idToken) {
        fetch(
          constants.urls.functionsBase +
            "getUserByOnlyEmail" +
            "?token=" +
            encodeURIComponent(idToken) +
            "&email=" +
            encodeURIComponent(email)
        )
          .then(response => response.json())
          .then(json => {
            if (json.error) {
              reject(json.error);
            } else {
              resolve(json);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  });
};

export const sendEmail = (email, subject, url) => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject("No User logged in!");
      return;
    }
    if (!email || typeof email !== "string") {
      reject("Invalid email!");
      return;
    }
    // if (!subscriptionId || typeof subscriptionId !== "string") {
    //   reject("Invalid subscription id!");
    //   return;
    // }

    let user = firebase.auth().currentUser;
    if (user) {
      user.getIdToken().then(function(idToken) {
        fetch(
          constants.urls.functionsBase +
            "sendEmail" +
            "?token=" +
            encodeURIComponent(idToken) +
            "&email=" +
            encodeURIComponent(email) +
            "&subject=" +
            encodeURIComponent(subject) +
            "&url=" +
            encodeURIComponent(url)
        )
          .then(response => response.json())
          .then(json => {
            if (json.error) {
              reject(json.error);
            } else {
              resolve(json);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  });
};

export const getUserByEmail = (email, subscriptionId) => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject("No User logged in!");
      return;
    }
    if (!email || typeof email !== "string") {
      reject("Invalid email!");
      return;
    }
    if (!subscriptionId || typeof subscriptionId !== "string") {
      reject("Invalid subscription id!");
      return;
    }

    let user = firebase.auth().currentUser;
    if (user) {
      user.getIdToken().then(function(idToken) {
        fetch(
          constants.urls.functionsBase +
            "getUserByEmail" +
            "?token=" +
            encodeURIComponent(idToken) +
            "&email=" +
            encodeURIComponent(email) +
            "&sid=" +
            encodeURIComponent(subscriptionId)
        )
          .then(response => response.json())
          .then(json => {
            if (json.error) {
              reject(json.error);
            } else {
              resolve(json);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  });
};

export const getUserByUid = (uid, subscriptionId) => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject("No User logged in!");
      return;
    }
    if (!uid || typeof uid !== "string") {
      reject("Invalid email!");
      return;
    }
    if (!subscriptionId || typeof subscriptionId !== "string") {
      reject("Invalid subscription id!");
      return;
    }
    let user = firebase.auth().currentUser;
    if (user) {
      user.getIdToken().then(function(idToken) {
        fetch(
          constants.urls.functionsBase +
            "getUserByUid" +
            "?token=" +
            encodeURIComponent(idToken) +
            "&uid=" +
            encodeURIComponent(uid) +
            "&sid=" +
            encodeURIComponent(subscriptionId)
        )
          .then(response => response.json())
          .then(json => {
            if (json.error) {
              reject(json.error);
            } else {
              resolve(json);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  });
};

export const getPlanDetails = plan_type => {
  return new Promise((resolve, reject) => {
    if (!(isNonEmptyString(plan_type) && validPlanTypes.includes(plan_type))) {
      reject("Invalid type!");
      return;
    }
    if (!store.state.user) {
      reject("No User logged in!");
      return;
    }
    let user = firebase.auth().currentUser;
    if (user) {
      user.getIdToken().then(function(idToken) {
        let fetchUrl =
          constants.urls.functionsBase +
          "getPlanDetails" +
          "?token=" +
          encodeURIComponent(idToken) +
          "&plan_type=" +
          encodeURIComponent(plan_type);

        fetch(fetchUrl)
          .then(response => response.json())
          .then(json => {
            if (json.error) {
              reject(json.error);
            } else {
              resolve(json);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  });
};

export const getSubscriptionUsers = id => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "getSubscriptionUsers" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&id=" +
              encodeURIComponent(id)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const revokeUserAccessToSubscription = (id, userId) => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "revokeUserAccessToSubscription" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&id=" +
              encodeURIComponent(id) +
              "&user=" +
              encodeURIComponent(userId)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const addUserToSubscription = (id, userId) => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "addUserToSubscription" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&id=" +
              encodeURIComponent(id) +
              "&user=" +
              encodeURIComponent(userId)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const editUserRole = (id, userId, role) => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "editUserRole" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&id=" +
              encodeURIComponent(id) +
              "&user=" +
              encodeURIComponent(userId) +
              "&role=" +
              encodeURIComponent(role)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

export const databaseGet = (
  ref,
  external = false,
  fromPaginate = 0,
  toPaginate
) => {
  return new Promise((resolve, reject) => {
    if (external) {
      fetch(ref)
        .then(data => data.json())
        .then(response => {
          resolve(response);
          setTimeout(() => {
            smartquotes();
          }, 1);
        })
        .catch(error => {
          reject(error);
        });
    } else {
      if (fromPaginate !== undefined && toPaginate) {
        firebase
          .database()
          .ref(ref)
          .orderByKey()
          .startAt(fromPaginate.toString())
          .endAt(toPaginate.toString())
          .once("value")
          .then(snapshot => {
            if (snapshot) {
              resolve(snapshot.val());
              setTimeout(() => {
                smartquotes();
              }, 1);
            } else {
              reject();
            }
          });
      } else {
        dbFs
          .collection(ref)
          .get()
          .then(function(snapshot) {
            if (snapshot) {
              // console.log("Document data:", snapshot.data());
              resolve(snapshot);
              setTimeout(() => {
                smartquotes();
              }, 1);
            } else {
              reject();
            }
          });
      }
    }
  });
};

export const uploadJobFiles = (sid, filesArray, updateProgress) => {
  return new Promise((resolve, reject) => {
    if (!(filesArray instanceof Array)) {
      reject("Invalid files array");
      return;
    }
    if (!(updateProgress instanceof Function) && updateProgress) {
      reject("Invalid function argument");
      return;
    }

    let progressArray = [];
    const subscriptionJobsRef = storage.ref(`${sid}/${dataNames.jobs.jobs}`);

    for (let index = 0; index < filesArray.length; index++) {
      progressArray[index] = {
        progress: 0,
        state: "Not started",
        error: null,
        isCompleted: false,
        downloadUrl: null,
        file: filesArray[index]
      };
    }

    const isAllCompleted = () => {
      for (let index = 0; index < progressArray.length; index++) {
        const thisProgress = progressArray[index];
        if (!thisProgress.isCompleted) {
          return false;
        }
      }
      return true;
    };

    const getErroredFiles = () => {
      let erroredFilesArray = [];
      for (let index = 0; index < progressArray.length; index++) {
        const thisProgress = progressArray[index];
        if (
          thisProgress.state === "Error" &&
          thisProgress.file instanceof File
        ) {
          erroredFilesArray.push(thisProgress.file);
        }
      }
      return erroredFilesArray;
    };

    for (let index = 0; index < progressArray.length; index++) {
      const thisIndex = index;

      const rejectWithError = errorMessage => {
        // report error in progress
        progressArray[thisIndex].state = "Error";
        progressArray[thisIndex].error = errorMessage;
        progressArray[thisIndex].isCompleted = true;
        updateProgress(progressArray);

        //if all other are completed then return
        if (isAllCompleted()) {
          reject(getErroredFiles());
        }
      };

      const resolveWithAll = downloadUrl => {
        // report progress
        progressArray[thisIndex].state = "Uploaded";
        progressArray[thisIndex].isCompleted = true;
        progressArray[thisIndex].downloadUrl = downloadUrl;

        updateProgress(progressArray);

        //if all other are completed then return
        if (isAllCompleted()) {
          resolve();
        }
      };

      const jobFile = progressArray[thisIndex].file;
      // make sure it is instace of file
      if (!(jobFile instanceof File)) {
        rejectWithError("Invalid file object");
      }

      //create a storage reference from dbfs id
      const newJobDbFsRef = dbFs.collection(dataNames.jobs.jobs).doc();
      let newJobFileName = newJobDbFsRef.id + "_" + jobFile.name;
      // console.log(
      //   "new job file name for " + jobFile.name + " is " + newJobFileName
      // );

      const uploadJobFileStorageRef = subscriptionJobsRef.child(newJobFileName);
      const uploadJobFileTask = uploadJobFileStorageRef.put(jobFile);

      //src: https://firebase.google.com/docs/storage/web/upload-files
      // Register three observers:
      // 1. 'state_changed' observer, called any time the state changes
      // 2. Error observer, called on failure
      // 3. Completion observer, called on successful completion
      uploadJobFileTask.on(
        "state_changed",
        function(snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          progressArray[thisIndex].progress = progress;

          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              progressArray[thisIndex].state = "Paused";
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              progressArray[thisIndex].state = "Uploading..";
              break;
          }

          updateProgress(progressArray);
        },
        function(error) {
          rejectWithError(error.code);
        },
        function() {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadJobFileTask.snapshot.ref
            .getDownloadURL()
            .then(function(downloadURL) {
              resolveWithAll(downloadURL);
            })
            .catch(() => {
              rejectWithError("Couldn't fetch download link");
            });
        }
      );
    }
  });
};
export const JobExportKmlLink = (jid, sid) => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then(function(idToken) {
          fetch(
            constants.urls.functionsBase +
              "getJobExportKmlLink" +
              "?token=" +
              encodeURIComponent(idToken) +
              "&jid=" +
              encodeURIComponent(jid) +
              "&sid=" +
              encodeURIComponent(sid)
          )
            .then(response => response.json())
            .then(json => {
              if (json.error) {
                reject(json.error);
              } else {
                resolve(json);
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  });
};

function isNonEmptyString(friendly_name) {
  return friendly_name || typeof friendly_name === "string";
}

export const CheckUserAccess = () => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      let user = firebase.auth().currentUser;
      let uid = user.uid;
      if (user) {
        dbFs
          .collection("user")
          .doc(uid)
          .get()
          .then(function(doc) {
            if (doc.exists) {
              if (doc.data().roleId != null) {
                checkUserRole(doc.data().roleId).then(data => {
                  store.dispatch("clearUserRole");
                  store.dispatch({
                    type: "updateUserRole",
                    UserRole: data
                  });
                  resolve(data);
                });
              } else {
                reject("Role Not Defiend");
              }
            } else {
              reject("User Not Grant");
            }
          })
          .catch(function(error) {
            reject(error);
            // console.log("Error getting document:", error);
          });
      }
    }
  });
};
export const checkUserRole = roleId => {
  return new Promise((resolve, reject) => {
    if (!roleId) {
      reject();
    } else {
      dbFs
        .collection("userRoles")
        .doc(roleId)
        .get()
        .then(function(doc) {
          if (doc.exists) {
            // console.log(doc.data());
            // let type = doc.data().type;
            // let access = doc.data().permission;
            resolve(doc.data());
          } else {
            reject("Role Not found");
          }
        })
        .catch(function(error) {
          reject("Error getting document:", error);
          // console.log("Error getting document:", error);
        });
    }
  });
};
export const UploadProductImages = imageData => {
  return new Promise((resolve, reject) => {
    const storageRef = firebase
      .storage()
      .ref(`products/${imageData.name}`)
      .put(imageData);
    error => {
      reject(error.message);
      // console.log(error.message);
    },
      function() {
        storageRef.snapshot.ref.getDownloadURL().then(url => {
          resolve(url);
        });
      };
  });
};
export const addProductIntoDb = product => {
  return new Promise((resolve, reject) => {
    dbFs
      .collection("product")
      .add(product)
      .then(() => {
        resolve("true");
      })
      .catch(error => {
        reject(error.code);
      });
  });
};

export const checkProductInVendor = productId => {
  // let vendor = vendorId;
  return new Promise((resolve, reject) => {
    dbFs
      .collection("vendorProducts")
      .where("productsId", "==", productId)
      // .where("vendorId", "==", vendorId)
      .get()
      .then(function(document) {
        if (!document.empty) {
          resolve("Allready");
        } else {
          resolve("NotFound");
        }
        // document.forEach(function(doc) {
        //   if (doc.exists) {
        //     // if (doc.data().vendorId == vendorId) {
        //     // } else {
        //     // }
        //   } else {
        //     resolve("NotFound");
        //   }
        //   // console.log(doc.id, " => ", doc.data());
        //   // console.log(doc.data().vendorId);
        // });
      })
      .catch(error => {
        reject(error);
      });
  });
};
export const getData = ref => {
  const products = [];
  dbFs
    .collection(ref)

    .get()
    .then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.data());
        products.push(doc.data());
      });
    });
  return products;
};
export const getProducts = () => {
  store.dispatch("clearProducts");
  let product = getData("products");
  store.dispatch({
    type: "updateProducts",
    products: product
  });
};
export const getWallet = () => {
  console.log("get");
  const Wallet = {
    txnRewardsBalance: 0,
    txnAamcartBalance: 0
  };
  let user = firebase.auth().currentUser;
  let uid = user.uid;
  if (uid) {
    dbFs
      .collection("wallet")
      .doc(uid)
      .get()
      .then(() => {
        if (Wallet.txnRewardsBalance == null) {
          let walletData = {
            txnRewardsBalance: 0
          };
          dbFs
            .collection("wallet")
            .doc(uid)
            .set(walletData, { merge: true });
        }
        if (Wallet.txnAamcartBalance == null) {
          let walletData = {
            txnAamcartBalance: 0
          };
          dbFs
            .collection("wallet")
            .doc(uid)
            .set(walletData, { merge: true });
        }
        this.getHistory();
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        store.dispatch("clearWallet");
        store.dispatch({
          type: "updateWallet",
          Wallet: Wallet
        });
      });
  }
};
export const updateWallet = (
  orderId,
  rewardAmm,
  walletRewardBalance,
  aamcartdAmm,
  walletAamcartdBalance,
  uId
) => {
  return new Promise((resolve, reject) => {
    if (rewardAmm == 0 && aamcartdAmm == 0) {
      reject();
    } else {
      if (rewardAmm !== 0) {
        let txnData = {
          refernceId: orderId,
          txnAmt: rewardAmm,
          txnStatus: true,
          pendingBalance: walletRewardBalance - rewardAmm,
          debitCredit: true,
          createdAt: Math.round(+new Date() / 1000),
          txtType: 0
        };
        let UpdateData = {
          txnRewardsBalance: walletRewardBalance - rewardAmm
        };
        dbFs
          .collection("wallet")
          .doc(uId)
          .collection("txnRewardsBalance")
          .add(txnData)
          .then(() => {
            dbFs
              .collection("wallet")
              .doc(uId)
              .set(UpdateData, { merge: true });
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            resolve();
          });
      }
      if (aamcartdAmm !== 0) {
        let txnData = {
          refernceId: orderId,
          txnAmt: aamcartdAmm,
          txnStatus: true,
          pendingBalance: walletAamcartdBalance - aamcartdAmm,
          debitCredit: true,
          createdAt: Math.round(+new Date() / 1000),
          txtType: 0
        };
        let UpdateData = {
          txnAamcartBalance: walletAamcartdBalance - aamcartdAmm
        };
        dbFs
          .collection("wallet")
          .doc(uId)
          .collection("txnAamcartBalance")
          .add(txnData)
          .then(() => {
            dbFs
              .collection("wallet")
              .doc(uId)
              .set(UpdateData, { merge: true });
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            resolve();
          });
      }
    }
  });
};
export const getVendorProducts = () => {
  store.dispatch("clearVendorProducts");
  let vendorProducts = getData("vendorProducts", 100);
  store.dispatch({
    type: "updateVendorProducts",
    vendorProducts: vendorProducts
  });
};
export const checkUser = email => {
  return new Promise((resolve, reject) => {
    if (!email) {
      reject();
    } else {
      dbFs
        .collection("user")
        .where("email", "==", email)
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(() => {
            // doc.data() is never undefined for query doc snapshots
            reject("User Allready Available");
          });
        })
        .catch(function(error) {
          reject(error);
          // console.log("Error getting document:", error);
        })
        .finally(() => {
          resolve("Not Found");
        });
    }
  });
};
export const getChecksum = orderId => {
  return new Promise((resolve, reject) => {
    if (!store.state.user) {
      reject();
    } else {
      fetch(
        constants.urls.functionsBase +
          "createChecksum" +
          "?ORDERID=" +
          encodeURIComponent(orderId)
      )
        .then(response => response.json())
        .then(json => {
          if (json.error) {
            reject(json.error);
          } else {
            resolve(json);
          }
        })
        .catch(error => {
          reject(error);
        });
    }
  });
};
